import { mdiLoading } from "@mdi/js";
import Icon from "@mdi/react";

interface Props {
  isVisible: boolean;
  message?: string;
}

export default function LoadingOverlay({ isVisible, message = "Saving changes..." }: Props) {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-foreground rounded-lg p-6 shadow-xl max-w-sm w-full mx-4">
        <div className="flex flex-col items-center">
          <Icon path={mdiLoading} size={2.5} className="text-primary mb-4 animate-spin" />
          <p className="text-center text-lg font-medium">{message}</p>
          <p className="text-center text-placeholder mt-2">
            Please wait while we process your request.
          </p>
        </div>
      </div>
    </div>
  );
}
